// Module
var code = "<h3>Personal Detail</h3> <div id=\"partyAccordions\"></div> <div class=\"flex justify-center items-center mt-10\"> <button id=\"next-btn\" onclick='thsSubTab.savePage(\"next_page\")'>Continue</button> </div> ";
// Exports
export default code;